// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"204":"83a4880a","477":"eb0cd923","719":"b33f8bd5","809":"17302df4","849":"cbba3f65"}[chunkId] + ".chunk.css";
};